// react_frontend/src/Components/Modules/Billing/AddCustomer.js
import React, { useState, useContext } from "react";
import Breadcrumb from "../../Partials/Breadcrumb";
import { Link, useNavigate } from "react-router-dom";
import { AxiosAuthInstance } from "../../../AxiosInterceptors";
import { MotherContext } from "../../../Context/MotherContext";

// RSuite Components
import {
  Button,
  Input,
  Message,
  toaster,
  Loader,
  Panel,
  FlexboxGrid,
} from "rsuite";
import "rsuite/dist/rsuite.min.css";

// Icons
import { FaUser, FaPhone, FaList, FaSave } from "react-icons/fa";

const AddCustomer = () => {
  const { addCustomerToList } = useContext(MotherContext);
  const [errors, setErrors] = useState({});
  const [isLodding, setIsLodding] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLodding(true);
    setErrors({});

    const formData = new FormData(e.currentTarget);

    try {
      const response = await AxiosAuthInstance.post("add_customer", formData);
      if (response.data.status === true) {
        toaster.push(
          <Message type="success" duration={3000}>
            Customer added successfully!
          </Message>,
          { placement: "topEnd" }
        );
        addCustomerToList(response.data.customer);
        navigate("/customers");
      }
    } catch (error) {
      const fieldErrors = error.response?.data?.errors || {};
      setErrors(fieldErrors);

      toaster.push(
        <Message type="error" duration={5000}>
          Failed to add customer.
        </Message>,
        { placement: "topEnd" }
      );
    } finally {
      setIsLodding(false);
    }
  };

  return (
    <>
      <Breadcrumb title="Add Customer" />

      <FlexboxGrid justify="center" className="p-3">
        <FlexboxGrid.Item colspan={12} md={8} lg={12} xl={8}>
          <Panel
            header={
              <div className="d-flex justify-content-between align-items-center">
                <h5 className="mb-0">
                  <FaUser /> Add New Customer
                </h5>
                <Link to="/customers" style={{ textDecoration: "none" }}>
                  <Button
                    className="custom-bg"
                    appearance="primary"
                    size="sm"
                    startIcon={<FaList />}
                  >
                    Customer List
                  </Button>
                </Link>
              </div>
            }
            bordered
            bodyFill
            style={{ backgroundColor: "white" }}
          >
            <form onSubmit={handleSubmit} className="p-3">
              <div className="mb-3">
                <label className="form-label"><strong>Name</strong></label>
                <Input name="customer_name" placeholder="Enter customer name" size="md" className={errors.customer_name ? "is-invalid" : ""} />
                {errors.customer_name && <div className="text-danger mt-1" style={{ fontSize: "12px" }}>{errors.customer_name[0]}</div>}
              </div>

              <div className="mb-3">
                <label className="form-label"><strong>Phone Number</strong></label>
                <Input name="customer_phone" type="tel" placeholder="Enter phone number" size="md" className={errors.customer_phone ? "is-invalid" : ""} />
                {errors.customer_phone && <div className="text-danger mt-1" style={{ fontSize: "12px" }}>{errors.customer_phone[0]}</div>}
              </div>

              <div className="mb-3">
                <label className="form-label"><strong>Email Address</strong></label>
                <Input name="customer_email" type="email" placeholder="Enter email address" size="md" className={errors.customer_email ? "is-invalid" : ""} />
                {errors.customer_email && <div className="text-danger mt-1" style={{ fontSize: "12px" }}>{errors.customer_email[0]}</div>}
              </div>

              <div className="mb-3">
                <label className="form-label"><strong>Address</strong></label>
                <Input name="customer_address" as="textarea" rows={3} placeholder="Enter full address" size="md" className={errors.customer_address ? "is-invalid" : ""} />
                {errors.customer_address && <div className="text-danger mt-1" style={{ fontSize: "12px" }}>{errors.customer_address[0]}</div>}
              </div>

              <div className="row">
                <div className="col-md-4 mb-3">
                  <label className="form-label"><strong>VAT / BIN No</strong></label>
                  <Input name="vat_number" placeholder="VAT Number" size="md" className={errors.vat_number ? "is-invalid" : ""} />
                  {errors.vat_number && <div className="text-danger mt-1" style={{ fontSize: "12px" }}>{errors.vat_number[0]}</div>}
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label"><strong>Tax / TIN No</strong></label>
                  <Input name="tax_number" placeholder="Tax Number" size="md" className={errors.tax_number ? "is-invalid" : ""} />
                  {errors.tax_number && <div className="text-danger mt-1" style={{ fontSize: "12px" }}>{errors.tax_number[0]}</div>}
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label"><strong>CR / Trade License</strong></label>
                  <Input name="cr_number" placeholder="CR Number" size="md" className={errors.cr_number ? "is-invalid" : ""} />
                  {errors.cr_number && <div className="text-danger mt-1" style={{ fontSize: "12px" }}>{errors.cr_number[0]}</div>}
                </div>
              </div>

              <div className="mt-4">
                <Button className="custom-bg" type="submit" appearance="primary" size="md" startIcon={<FaSave />} disabled={isLodding} style={{ width: "100%" }}>
                  {isLodding ? <><Loader size="sm" /> Saving...</> : "Add Customer"}
                </Button>
              </div>
            </form>
          </Panel>
        </FlexboxGrid.Item>
      </FlexboxGrid>
    </>
  );
};

export default AddCustomer;